import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import InventoryIcon from '@mui/icons-material/Inventory';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import ReportIcon from '@mui/icons-material/Report';
import { Typography, Box } from '@mui/material';
import { TransportStatus as TransportStatusEnum } from 'models/transport';

type TransportStatusProps = {
    status: TransportStatusEnum;
    hasProblem: boolean | undefined;
};
const TransportStatus: FC<TransportStatusProps> = ({ status, hasProblem }: TransportStatusProps) => {
    const { t: translate } = useTranslation(['transport']);

    const getStatusColor = (status: TransportStatusEnum) => {
        switch (status) {
            case TransportStatusEnum.PICKED_UP:
            case TransportStatusEnum.PLANNED:
                return '333333';
            case TransportStatusEnum.DELIVERED:
                return '007e33';
            case TransportStatusEnum.MISSED:
                return 'cc0000';
            default:
                return undefined;
        }
    };

    const renderIcon = (status: TransportStatusEnum) => {
        switch (status) {
            case TransportStatusEnum.PLANNED:
                return <InventoryIcon />;
            case TransportStatusEnum.PICKED_UP:
                return <LocalShippingIcon />;
            case TransportStatusEnum.DELIVERED:
                return <CheckCircleIcon style={{ color: '#007e33' }} />;
            case TransportStatusEnum.MISSED:
                return <ErrorIcon style={{ color: '#cc0000' }} />;
            default:
                return undefined;
        }
    };

    return (
        <Fragment>
            {hasProblem ? (
                <Box display="flex" alignItems="center">
                    <ReportIcon color="warning" />
                    <Typography variant="caption" color="#ED6C02">
                        {translate('transport:UNDER_OBSERVATION')}
                    </Typography>
                </Box>
            ) : (
                <Box display="flex" alignItems="center">
                    {renderIcon(status)}
                    <Typography sx={{ color: getStatusColor(status) }} variant="subtitle2">
                        {translate(status as string)}
                    </Typography>
                </Box>
            )}
        </Fragment>
    );
};

export default TransportStatus;
